import { useTranslation } from 'react-i18next';
import { CraftAssetDownload } from '#pie/components/craft-asset-download/CraftAssetDownload';
import type { CreateDataRequestDto } from '#pie/internal/api/pie-bff';
import { AddressLevel } from '#pie/internal/api/pie-bff';
import { typedFormFields } from '#pie/utils/typedFormFields';

const { ConditionalField, FormFile } = typedFormFields<CreateDataRequestDto>();

export const CustomerMandateFile = () => {
  // Stuur ingevuld klantmandaat mee
  const { t } = useTranslation('dataRequest');

  return (
    <ConditionalField
      field="customerMandateFile"
      condition={(fieldValue) =>
        fieldValue('addressLevel') === AddressLevel.Individual
      }
    >
      <FormFile
        label={t('customer_mandate_file')}
        name="customerMandateFile"
        rules={{ required: true }}
      />
      <CraftAssetDownload title="Voorbeeld toestemmingsformulier klantmandaat" />
    </ConditionalField>
  );
};
